export const DataChannelReadyState = {
    CONNECTING: 'connecting',
    OPEN: 'open',
    CLOSING: 'closing',
    CLOSED: 'closed',
}



// WEBPACK FOOTER //
// ../src/data/Const.ts